import React from 'react';

import styles from './Review.module.css'
import {avatarIcon, starIcon} from "../../../assets/icons/icons.ts";
import {formatDate} from "../../../utils/formatters/index.ts";

interface Props {
    text: string
    author: string
    date: string
}

export const Review: React.FC<Props> = ({text, author, date}) => {
    return (
        <article className={styles.review}>
            <div className={styles.logo}>
                <img src={avatarIcon} alt='Аватар'/>
            </div>
            <address className={styles.author}>
                <span>{author}</span>
                <time dateTime={date} className={styles.date}>
                    {formatDate(date)}
                </time>
            </address>
            <div className={styles.rating}>
                <img src={starIcon} alt='Рейтинг'/>
                <img src={starIcon} alt='Рейтинг'/>
                <img src={starIcon} alt='Рейтинг'/>
                <img src={starIcon} alt='Рейтинг'/>
                <img src={starIcon} alt='Рейтинг'/>
            </div>
            <blockquote className={styles.text}>
                {text}
            </blockquote>
            <div className={styles.line}></div>
            <a className={styles.link} target='_blank' href="https://2gis.ru/vladivostok/firm/3518965490169024/tab/reviews">Посмотреть отзывы на 2 Gis</a>
        </article>
    );
};